import { gql } from '@apollo/client';
import React from 'react';
import { isDiscounted } from '../../lib/variantUtils/isDiscounted';
import { ColorSwitcherDescriptionVariantFragment } from '../../generated/types/ColorSwitcherDescriptionVariantFragment';
import './ColorSwitcherDescription.scss';
import { capitalizeWord } from '../../lib';

export const COLOR_SWITCHER_DESCRIPTION_VARIANT_FRAGMENT = gql`
  fragment ColorSwitcherDescriptionVariantFragment on VariantData {
    color
    soldOut: sold_out
    prices(country_code: $countryCode) {
      originalPrice: original_price {
        price
      }
      currentPrice: current_price {
        price
      }
    }
  }
`;

interface Props {
  colorDetailsVariant: ColorSwitcherDescriptionVariantFragment;
}
export const ColorSwitcherDescription: React.FC<Props> = ({ colorDetailsVariant }) => {
  return (
    <div className="ColorSwitcherDescription">
      Color
      <span className="ColorSwitcherDescription__dash">—</span>
      <span>{capitalizeWord(colorDetailsVariant.color)}</span>
      {colorDetailsVariant.soldOut && (
        <>
          <span className="ColorSwitcherDescription__dash">—</span>
          <span className="ColorSwitcherDescription__sold-out-text">Sold Out</span>
        </>
      )}
      {!colorDetailsVariant.soldOut && isDiscounted(colorDetailsVariant.prices) && (
        <>
          <span className="ColorSwitcherDescription__dash">—</span>
          <span className="ColorSwitcherDescription__sale-text">Sale</span>
        </>
      )}
    </div>
  );
};
